






























































































import { defineComponent, computed, PropType, ref } from "@vue/composition-api";
import AttachedDeviceModel from "@/models/AttachedDeviceModel";
import useSwitchDevice from "@/store/modules/useSwitchDevice";
import { sensor } from "@/store";
import useTimerSchedule from "@/store/useTimerSchedule";

export default defineComponent({
    components: {
        SensorHeader: () =>
            import(/* webpackChunkName: "components" */ "./SensorHeader.vue"),
        PairToggle: () =>
            import(/*webpackChunkName: "components"*/ "../PairToggle.vue"),
        SensorPanelLayout: () =>
            import(/* webpackChunkName: "components" */ "./SensorPanelLayout.vue"),
        TimerDialog: () =>
            import(/* webpackChunkName: "settings" */ "../Dialogs/TimerDialog.vue"),
        ConsumptionDialog: () =>
            import(/* webpackChunkName: "settings" */ "../Dialogs/ConsumptionDialog.vue"),
    },
    props: {
        value: Object as PropType<AttachedDeviceModel>
    },
    setup(props, { emit }) {
        const { turnOn, turnOff } = useSwitchDevice();
        const { get } = useTimerSchedule();

        const paired = computed(() => !!(props.value?.attachedDeviceId));

        const isConnecting = computed(() =>
            props.value?.isConnecting === true
        );

        const responsive = computed(() =>
            props.value?.attachedDeviceId != null ? props.value.age < 4 : false
        );

        const switchStatus = computed<boolean>(() => {
            return ((props.value as any)?.status === true);
        });

        const showTimer = ref(false);
        const showConsumption = ref(false);

        const imgSrc = computed(() => require(`@/assets/img/shorepower.png`));

        const onEnroll = () => {
            if (props.value) emit('enroll', { typeId: props.value.attachedDeviceTypeId, img: imgSrc.value });
        };

        const onUnpair = () => {
            if (props.value) emit('unpair', { deviceId: props.value.attachedDeviceId })
        }

        const openTimer = () => { showTimer.value = true; };
        const openConsumption = () => { showConsumption.value = true; };

        const sensorSyncronising = computed(() => !!((props.value as any)?.isBusy || (props.value as any)?.isConnecting));

        const switchChange = (next: boolean) => {
            if (!props.value) return;
            // Send command
            if (next) turnOn(props.value.attachedDeviceId);
            else turnOff(props.value.attachedDeviceId);
            // Optimistic UI
            (props.value as any).status = next;
        };

        if (props.value) get(props.value.attachedDeviceTypeId);

        return {
            onEnroll,
            onUnpair,
            openTimer,
            openConsumption,
            paired,
            showTimer,
            showConsumption,
            imgSrc,
            responsive,
            switchStatus,
            sensorSyncronising,
            switchChange,
            isConnecting,
        };
    }
});
